import styled from 'styled-components';

export const StyledContent = styled.div`
  cursor: help;
`;

export const StyledTooltipContent = styled.p`
  margin: 0;
  padding: 0.25rem;
`;
